import { fromJS } from "immutable"
import {
  GET_MEASURE_ENGAGEMENT_WATCHER,
  GET_MEASURE_ENGAGEMENT_SUCCESS,
  GET_MEASURE_ENGAGEMENT_FAILED,
  GET_DIMENSIONS_DATA_WATCHER,
  GET_DIMENSIONS_DATA_SUCCESS,
  GET_DIMENSIONS_DATA_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  measureEngagement: null,
  isLoadingDimensionsData: false,
  dimensionsData: {},
})

function engagementMeasurementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MEASURE_ENGAGEMENT_WATCHER:
      return state.set("isLoading", true)
    case GET_MEASURE_ENGAGEMENT_SUCCESS:
      return state
        .set("isLoading", false)
        .set("measureEngagement", action.payload)
    case GET_MEASURE_ENGAGEMENT_FAILED:
      return state.set("isLoading", false).set("measureEngagement", null)

    case GET_DIMENSIONS_DATA_WATCHER:
      return state.set("isLoadingDimensionsData", true)
    case GET_DIMENSIONS_DATA_SUCCESS:
      return state
        .set("isLoadingDimensionsData", false)
        .set("dimensionsData", action.payload)
    case GET_DIMENSIONS_DATA_FAILED:
      return state.set("isLoadingDimensionsData", false).set("dimensionsData", {})

    default:
      return state
  }
}

export default engagementMeasurementReducer
